import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FlexModule } from '@angular/flex-layout'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTabsModule } from '@angular/material/tabs'
import { PipesModule } from '@mmx/pipes'
import { DirectivesModule } from '@mmx/shared'
import { TranslateModule } from '@ngx-translate/core'

import { CodesSelectorInputComponent } from '../codes-selector'
import { CustomFieldsFormComponent } from '../custom-fields-form'
import { DateFieldModule } from '../date-selector'
import { DiagnosisCodeChipsSelectorComponent } from '../diagnosis-code-chips-selector/diagnosis-code-chips-selector.component'
import { FacilitySelectorModule } from '../facility-selector'
import { FileInputModule } from '../file-input'
import { FormErrorModule } from '../form-error'
import { PriorAuthorizationFormModule } from '../prior-authorization-form'
import { AuthorizationDialogComponent } from './authorization-dialog.component'
import { AuthClinicalInformationComponent, AuthDetailsFormComponent, AuthStatusDetailsComponent } from './components'

@NgModule({
  imports: [
    CommonModule,
    DateFieldModule,
    FormErrorModule,
    CustomFieldsFormComponent,
    CodesSelectorInputComponent,
    DiagnosisCodeChipsSelectorComponent,
    DirectivesModule,
    MatTabsModule,
    AuthClinicalInformationComponent,
    PriorAuthorizationFormModule,
    FacilitySelectorModule,
    TranslateModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatProgressBarModule,
    FlexModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatInputModule,
    FileInputModule,
    PipesModule,
    AuthStatusDetailsComponent,
  ],
  declarations: [
    AuthDetailsFormComponent,
    AuthorizationDialogComponent,
  ],
})
export class AuthorizationDialogModule {}
